import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from "react-loader";
import { CSSTransition } from "react-transition-group";
import Scrollbars from "react-custom-scrollbars";
import { toast, ToastContainer } from "react-toastify";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";

import withServices from "../../../HOCs/withServices";

import { connect } from "react-redux";

import Navbar from "../../../components/CustomNav/CustomNav.Component";
import CustomBarChart from "../../../common/DataViz/customBarChart.Component";
import CustomDonutChart from "../../../common/DataViz/customDonutChart.Component";
import CustomRadialChart from "../../../common/customRadialChart.Component";
import {
  currentBaseUrl,
  currentUser,
  currentUserId,
  currentProfile,
  getGeneralSmartTableData,
  isUserLoggedIn,
  isUserUpgraded,
  zeroPaddedStr,
  setProfileData,
  isSubscriptionOwner,
  clearSessionData,
  currentUserEmail,
} from "../../../common/services";

import "../School/schoolDataCenter.css";
import CustomSingleSpeedo from "../../../common/customSingleSpeedo.Component";
import ModalVideo from "react-modal-video";
import StackedBarGraph from "../../../common/DataViz/stackedBarGraph.Component";
import ClickOutside from "react-click-outside";
import Sidenav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { IoMdClose } from "react-icons/io";
import Modal from "react-awesome-modal";

import { FabButton } from "../../Onboard/Common/Common.styles";
import { tourSteps } from "./TeacherDataCenterTour";

import {
  getUserTypeAssessments,
  getCohortsList,
  getCurrentAssessmentStats,
  getAlertLevelsBreakdown,
  getCohortsListFiltered,
  getCurrentProfile,
  getInstitutionAssessments,
} from "../../../redux/ducks/teacherDataCenter";

interface IProps {
  services?: any;
  history?: any;
  dataCenterReducer?: any;
  dispatch?: any;
}

class TeacherDataCenter extends React.Component<IProps> {
  public state = {
    baseurl: currentBaseUrl(),
    currentUser: currentUser(),
    destination: "",
    navigate: false,
    toLogin: false,
    toProfile: false,
    toLevelData: false,
    isVidModalOpen: false,
    videoLink: "",
    sideNavOpen: false,
    sideNavCategory: "summary",
    deactivateForFE: true,
    guidesRead: true,
    csvUploaded: false,
    downloadOpen: false,
    downloadCohort: "",
    uploadsOpen: false,
    downloadComplete: false,
    sid: null,
    socketLoading: false,
    singleZipOpen: false,
    fullSuiteModal: false,
    completionStatusModal: false,
  };

  private URNRef = React.createRef<HTMLInputElement>();
  private departmentRef = React.createRef<HTMLInputElement>();

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.exploreLevelData = this.exploreLevelData.bind(this);
    this.handleGenSmartDataLoaded = this.handleGenSmartDataLoaded.bind(this);
    this.getCurrentScreen = this.getCurrentScreen.bind(this);
    this.toSearchFilters = this.toSearchFilters.bind(this);
    this.schoolResources = this.schoolResources.bind(this);
    this.onSelectAssessment = this.onSelectAssessment.bind(this);
    this.assessmentPicker = this.assessmentPicker.bind(this);
    // this.reportCommands = this.reportCommands.bind(this);
    this.toStudentList = this.toStudentList.bind(this);
    this.toDataCentre = this.toDataCentre.bind(this);
    this.uploadCSV = this.uploadCSV.bind(this);
    this.downloadCohortReport = this.downloadCohortReport.bind(this);
  }

  public onSocketConnect = (e) => {
    console.log("connected");
  };

  public onMessage(socketMessage) {
    this.setState({ socketLoading: false });
    const link = socketMessage.message.data.link;
    window.open(link, "_blank");
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  // public componentWillUnmount() {
  //   console.log("removing sockets");
  //   socket.off("customNotif");
  // }

  public async componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
    } else {
      this.setState({ username: currentUser() });

      this.props.dispatch(getInstitutionAssessments());
      // socket.on("connect", this.onSocketConnect);

      // socket.on("customEmit", (data) => this.onSetup(data));

      // socket.on("customNotif", (data) => this.onMessage(data));

      // socket.emit("customMsg", { evt: "init" });

      // const tourStatus = localStorage.getItem(`${currentUser()}DataCenterTour`);
      // if (tourStatus === null) {
      //   setTimeout(() => {
      //     this.openVideoModal("525083745");
      //   }, 2000);
      // }
    }
  }

  public handleOpenModal = (event) => {
    this.openVideoModal(event.target.value);
  };

  public openVideoModal = (vidLink) => {
    this.setState({ isVidModalOpen: true, videoLink: vidLink });
  };

  public toggleDownloadModal = () => {
    const { downloadOpen } = this.state;
    this.setState({ downloadOpen: !downloadOpen });
  };
  public toggleSingleZipModal = () => {
    const { singleZipOpen } = this.state;
    this.setState({ singleZipOpen: !singleZipOpen });
  };

  public toggleUploadsModal = () => {
    const { uploadsOpen } = this.state;
    this.setState({ uploadsOpen: !uploadsOpen });
  };

  public toggleFullSuiteReport = () => {
    const { fullSuiteModal } = this.state;
    this.setState({ fullSuiteModal: !fullSuiteModal });
  };
  public toggleCompletionStatusModal = () => {
    const { completionStatusModal } = this.state;
    this.setState({ completionStatusModal: !completionStatusModal });
  };

  public closeVideoModal = () => {
    this.setState({ videoLink: "", isVidModalOpen: false });
  };
  public onClickOutside = () => {
    this.setState({ sideNavOpen: false });
  };
  public toggleSideNav = () => {
    const navstate = this.state.sideNavOpen;
    this.setState({ sideNavOpen: !navstate });
  };
  public toggleGuides = () => {
    // this.ls.removeItem(localStorageKey);
    const { guidesRead } = this.state;
    this.setState({ guidesRead: !guidesRead });
  };

  public closeTour = () => {
    localStorage.setItem(`${currentUser()}DataCenterTour`, "true");
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };
  public chooseCategory = (evtKey, event) => {
    this.setState({ sideNavCategory: evtKey });
  };

  public isFilterSelected = (filter) => {
    const { queryArray } = this.props.dataCenterReducer;
    const idx = queryArray.findIndex((el) => el.includes(`${filter}`));
    if (idx >= 0) {
      return true;
    }
    return false;
  };

  public openURNUpload = () => {
    const uploader = this.URNRef.current;
    if (uploader) {
      uploader.click();
    }
  };
  public openDeptCodeUpload = () => {
    const uploader = this.departmentRef.current;
    if (uploader) {
      uploader.click();
    }
  };

  public closeUploadModal = () => {
    this.setState({ csvUploaded: false });
  };

  public closeDownloadCompleteModal = () => {
    this.setState({ downloadComplete: false });
  };

  public async uploadCSV(type, e) {
    const formData = new FormData();
    const {
      services: { institutionsAPI },
    } = this.props;
    for (const file of e.target.files) {
      formData.append("files", e.target.files[0]);
    }
    if (type === "urn") {
      const confirmed = confirm(
        "Please do not navigate away from this page, if you do, your URN’S will not be uploaded"
      );
      if (!confirmed) {
        return;
      }

      this.setState({ socketLoading: true });

      const urnRes = await institutionsAPI.uploadInstitutionURN(
        formData,
        this.state.sid
      );
      if (urnRes.ok) {
        this.setState({ csvUploaded: true });
        toast.success("File uploaded successfully");
      }
    }
    if (type === "dept") {
      const confirmed = confirm(
        "Please do not navigate away from this page, if you do, your Department Codes will not be uploaded"
      );
      if (!confirmed) {
        return;
      }
      const deptRes = await institutionsAPI.uploadDepartmentCodes(formData);
      if (deptRes.ok) {
        this.setState({ csvUploaded: true });
        toast.success("File uploaded successfully");
      }
    }
  }

  public uploadActions = () => {
    return (
      <div
        style={{ position: "fixed", bottom: "0", width: "85%" }}
        className="school-center-profile"
      >
        <h2 style={{ textAlign: "center" }} className="school-profile-title">
          REGISTER YOUR LEARNERS TO PERFORMANCE LEARNING
        </h2>
        <div className="school-profile-holder">
          <input
            style={{ display: "none" }}
            ref={this.URNRef}
            id="urn-upload"
            type="file"
            name="urn-upload"
            accept=".csv"
            multiple={true}
            required={true}
            onChange={this.uploadCSV.bind(this, "urn")}
          />

          <input
            style={{ display: "none" }}
            ref={this.departmentRef}
            id="dept-upload"
            type="file"
            name="dept-upload"
            accept=".csv"
            multiple={true}
            required={true}
            onChange={this.uploadCSV.bind(this, "dept")}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "50%",
              justifyContent: "center",
            }}
          >
            <button
              onClick={this.openURNUpload}
              className="blue-button upload-files"
              style={{ minWidth: "300px", marginRight: "2em", width: "90%" }}
            >
              Upload URNs
            </button>
            <a
              className="template-link"
              target="_blank"
              href="https://plexdata.s3.eu-west-2.amazonaws.com/samples/plex_registration_form.csv"
            >
              Download URN Template
            </a>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "50%",
              justifyContent: "center",
            }}
          >
            <button
              onClick={this.openDeptCodeUpload}
              className="blue-button upload-files"
              style={{ minWidth: "300px", marginRight: "2em", width: "90%" }}
            >
              Upload Department Codes
            </button>
            <a
              className="template-link"
              target="_blank"
              href="https://plexdata.s3.eu-west-2.amazonaws.com/samples/plex_additional_information_form.csv"
            >
              Download Department Codes Template
            </a>
          </div>
        </div>
      </div>
    );
  };

  // public reportCommands() {
  //   const { cohorts } = this.props.dataCenterReducer;
  //   if (cohorts.length) {
  //     return (
  //       <React.Fragment>
  //         <div className="school-center-profile status-reports">
  //           <h2 className="school-profile-title">Reports</h2>
  //           <div className="school-profile-holder">
  //             <button
  //               style={{ width: "45%" }}
  //               className="blue-button learnmore step-12"
  //               onClick={this.toggleCompletionStatusModal}
  //             >
  //               Completion Status Report (CSV)
  //             </button>
  //             <button
  //               style={{ width: "45%" }}
  //               className="blue-button learnmore step-14"
  //               onClick={this.toggleFullSuiteReport}
  //             >
  //               Full Suite Of Reports (PDF)
  //             </button>
  //           </div>
  //           <div className="school-profile-holder">
  //             <button
  //               style={{
  //                 marginTop: "1.75em",
  //                 width: "45%",
  //                 alignSelf: "flex-start",
  //               }}
  //               className="blue-button learnmore step-13"
  //               onClick={this.toggleSingleZipModal}
  //             >
  //               Full Suite Of Getting To Know You Reports (PDFS)
  //             </button>
  //           </div>
  //         </div>
  //       </React.Fragment>
  //     );
  //   } else {
  //     return "";
  //   }
  // }

  public onSelectUserType = (e) => {
    const {
      services: { currentUserID },
      dispatch,
    } = this.props;

    if (e.target.value === "") {
      return;
    }

    dispatch(getCurrentProfile(currentUserID));
    dispatch(getUserTypeAssessments(currentUserID, e.target.value));

    this.setState({ downloadCohort: null });
  };

  public onSelectAssessment = (event) => {
    const selectedAssessment = event.target.value;

    this.props.dispatch(getCohortsList(selectedAssessment));
    // this.loadCohort(selectedAssessment);
  };

  public onSelectAssessmentCohort = (type, e) => {
    if (type === "download") {
      this.setState({ downloadCohort: e.target.value });
    }
    if (type === "breakdown") {
      // call loadAlertBreakdown and loadCurrentAssessmentStats
      this.loadCurrentAssessmentStats(e.target.value, true);
      this.loadAlertBreakdownWithFilter(e.target.value);
      this.setState({ downloadCohort: e.target.value });
    }
  };

  public onSelectFilter = (filter, e) => {
    const { queryArray, selectedCohort } = this.props.dataCenterReducer;

    const idx = queryArray.findIndex((el) => el.includes(`${filter}`));
    const filterString = e.target.value.length
      ? `${filter}=${e.target.value}`
      : "";

    if (idx >= 0) {
      queryArray.splice(idx, 1, filterString);
      if (!e.target.value.length) {
        queryArray.splice(idx, 1);
      }
    } else {
      queryArray.push(filterString);
    }

    this.props.dispatch({ type: "UPDATE_QUERY_ARRAY", payload: queryArray });

    this.loadCurrentAssessmentStats(selectedCohort, false);
    this.loadAlertBreakdownWithFilter(selectedCohort);
    this.loadCohortWithFilter();
  };

  public loadCurrentAssessmentStats(cohort, clearFilters = false) {
    const {
      services: { currentUserID, institutionsAPI },
      dataCenterReducer: { currentUserType, selectedAssessment, queryArray },
      dispatch,
    } = this.props;

    const query = queryArray.join("&");

    dispatch(
      getCurrentAssessmentStats(selectedAssessment, cohort, query, clearFilters)
    );

    const tourStatus = localStorage.getItem(`${currentUser()}DataCenterTour`);
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }

    this.setState({ guidesRead });
  }

  public loadAlertBreakdownWithFilter(cohort) {
    const {
      services: { currentUserID, fixturesAPI, institutionsAPI },
      dataCenterReducer: { selectedAssessment, queryArray },
      dispatch,
    } = this.props;

    const filter = queryArray.join("&");

    dispatch(getAlertLevelsBreakdown(selectedAssessment, cohort, filter));
  }

  public loadCohortWithFilter() {
    const {
      dataCenterReducer: { queryArray, selectedAssessment },
      services: { currentUserID },
      dispatch,
    } = this.props;
    const filter = queryArray.join("&");

    dispatch(getCohortsListFiltered(currentUserID, selectedAssessment, filter));
  }

  public async downloadCohortReport(type) {
    const { downloadCohort } = this.state;
    const {
      services: { currentUserID, institutionsAPI },
      dataCenterReducer: { selectedAssessment },
    } = this.props;

    if (!downloadCohort) {
      toast.warn("You must pick a cohort");
      return;
    }
    this.setState({ socketLoading: true });

    let downloadRes;
    if (type === "assessment-report") {
      downloadRes =
        await this.props.services.institutionsAPI.generateAssessmentCohortReport(
          currentUserID,
          selectedAssessment,
          downloadCohort,
          this.state.sid
        );
    }

    if (type === "single-page") {
      downloadRes = await this.props.services.institutionsAPI.getSinglePageZip(
        currentUserId(),
        selectedAssessment,
        downloadCohort,
        this.state.sid
      );
    }

    if (type === "full-suite") {
      downloadRes = await institutionsAPI.genInstitutionAssessmentZip(
        currentUserID,
        downloadCohort,
        selectedAssessment,
        this.state.sid
      );
    }

    if (type === "completion-status") {
      downloadRes = await institutionsAPI.genInstitutionAssessmentCSV(
        currentUserID,
        downloadCohort,
        selectedAssessment,
        this.state.sid
      );
    }

    if (downloadRes.ok) {
      this.setState({
        downloadOpen: false,
        downloadComplete: true,
        singleZipOpen: false,
      });
    } else {
      toast.error("Ooops, the report could not be generated, try again.");
    }
  }

  public getCurrentScreen() {
    if (this.state.sideNavCategory === "summary") {
      return this.renderFirstScreen();
    } else if (this.state.sideNavCategory === "filters") {
      return this.toSearchFilters();
    } else if (this.state.sideNavCategory === "studentlist") {
      return this.toStudentList();
    } else if (this.state.sideNavCategory === "datacentre") {
      return this.toDataCentre();
    } else if (this.state.sideNavCategory === "perceptions") {
      this.toPerceptions();
    } else if (this.state.sideNavCategory === "teacherlist") {
      this.toTeacherList();
    } else {
      return <div>No data to show yet</div>;
    }
  }

  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      this.setState({ loaded: true });
      this.setState({ [key]: res.response[objkey] });
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public onProfile(arg) {
    this.props.history.push(`${currentBaseUrl()}profilepage`);
  }

  public toSearchFilters() {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}filter`);
  }

  public toStudentList() {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}studentlist`);
  }
  public toTeacherList() {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}teachers`);
  }
  public toPerceptions = () => {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}perceptions`);
  };
  public toDataCentre() {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}datacentre`);
  }

  public onLogout(arg) {
    this.setState({ tologin: true });
  }

  public exploreLevelData(item) {
    const { currentUserType, selectedCohort } = this.props.dataCenterReducer;
    // const routeChoice =
    //   currentUserType === "teachers" ? "teachers" : "students";
    const { history } = this.props;
    console.log(
      "path: ",
      `${currentBaseUrl()}students/alertlevel/${item.achieved}/${
        item.assessmentid
      }/${selectedCohort}`
    );
    history.push(
      `/teachers/alertlevel/${item.achieved}/${item.assessmentid}/${selectedCohort}`
    );
  }

  public assessmentPicker() {
    const {
      assessments,
      showAssessmentPicker,
      currentUserType,
      selectCohorts,
      selectedCohort,
      selectedAssessment,
      cohortsLoaded,
      yearGroups,
      departments,
    } = this.props.dataCenterReducer;

    console.log({ selectCohorts });
    console.log({ selectedCohort });
    // console.log({selectCohorts})

    return (
      <div className="sf-query-wrapper">
        <div className="sf-query">
          {/* assessment options */}
          <div
            className={`${
              showAssessmentPicker
                ? "show-picker step-3"
                : "hide-search-picker "
            }`}
          >
            <span>Choose an assessment to explore &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectAssessment}
                style={{ width: "250px" }}
              >
                <option> -- </option>
                {assessments.map((assessment) => (
                  <option
                    selected={assessment.id === +selectedAssessment}
                    key={assessment.id}
                    value={assessment.id}
                  >
                    {assessment.name}
                  </option>
                ))}
              </select>
            </span>
          </div>

          {/* Cohorts */}
          <div
            className={`${
              showAssessmentPicker
                ? "show-picker step-3"
                : "hide-search-picker "
            }`}
          >
            <span>Choose a cohort &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectAssessmentCohort.bind(this, "breakdown")}
                style={{ width: "250px" }}
              >
                <option value=""> -- </option>
                {selectCohorts.map((cohort) => (
                  <option
                    selected={cohort.assessment === selectedCohort}
                    key={cohort.assessment}
                    value={cohort.assessment}
                  >
                    {cohort.assessment}
                  </option>
                ))}
              </select>
            </span>
          </div>

          {/* yeargrp */}
          <div
            className={`${
              cohortsLoaded ? "show-picker step-5" : "hide-search-picker "
            }`}
          >
            <span>Choose a year group &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectFilter.bind(this, "year_group")}
                style={{ width: "250px" }}
              >
                <option value=""> -- </option>
                {yearGroups.map((grp) => (
                  <option
                    selected={this.isFilterSelected(grp)}
                    key={grp}
                    value={grp}
                  >
                    {grp}
                  </option>
                ))}
              </select>
            </span>
          </div>

          <div
            className={`${
              cohortsLoaded ? "show-picker step-4" : "hide-search-picker "
            }`}
          >
            <span>Choose a department &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectFilter.bind(this, "department")}
                style={{ width: "250px" }}
              >
                <option value=""> -- </option>
                {departments.map((dept) => (
                  <option
                    selected={this.isFilterSelected(dept)}
                    key={dept}
                    value={dept}
                  >
                    {dept}
                  </option>
                ))}
              </select>
            </span>
          </div>
        </div>
      </div>
    );
  }

  public overallProgress() {
    const { currentProfile } = this.props.dataCenterReducer;
    if (currentProfile.Profiledata && !this.state.deactivateForFE) {
      return (
        <div className="school-center-progress">
          <h2 className="school-row-title">OVERALL PROGRESS</h2>
          <div className="school-ploa-score">
            {" "}
            {/*existing ploa score */}
            <CustomBarChart
              value={currentProfile.Profiledata.avg_ploa_score}
              color="#e7233d"
              strokeSize={8}
            />
            <h3 className="barchart-description">Existing Ploa Score</h3>
          </div>
          <div className="school-ploa-score">
            {" "}
            {/*ploa target */}
            <CustomBarChart
              value={currentProfile.Profiledata.avg_target_ploa_score}
              color="#18ee97"
              strokeSize={8}
            />
            <h3 className="barchart-description">Target Ploa Score</h3>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }

  public schoolProfile() {
    const {
      assessmentsLoaded,
      loaded,
      currentAssessmentStats,
      // currentProfile,
    } = this.props.dataCenterReducer;

    if (assessmentsLoaded) {
      return (
        <div className="school-center-profile step-6">
          <h2 className="school-profile-title" style={{ fontSize: "24px" }}>
            PROFILE
          </h2>
          <div className="school-profile-holder">
            <div style={{ width: "20%" }} className="school-details">
              <h4 className="detail-name">Name</h4>
              <p className="detail-value">{currentUser()}</p>
              <h4 className="detail-name">Address</h4>
              <p className="detail-value">{currentUserEmail}</p>
              <h4 className="detail-name">Code</h4>
              <p className="detail-value">
                {currentProfile().ParentStudentCode}
              </p>
            </div>{" "}
            {/* end school details */}
            <div style={{ width: "20%" }} className="school-summary-values">
              <CustomDonutChart
                value={100}
                color="#18ee97"
                alertLevel="no"
                text={zeroPaddedStr(currentAssessmentStats.learner_count)}
              />
              <h4 className="detail-name">Learners</h4>
            </div>
            <div style={{ width: "20%" }} className="school-summary-values">
              <CustomDonutChart
                value={100}
                color="#18ee97"
                alertLevel="no"
                text={zeroPaddedStr(
                  currentAssessmentStats.completed_scores_count
                )}
              />
              <h4 className="detail-name">Completed Assessments</h4>
            </div>
            <div style={{ width: "20%" }} className="school-summary-values">
              <CustomDonutChart
                value={100}
                color="#e7233d"
                alertLevel="no"
                text={zeroPaddedStr(
                  currentAssessmentStats.learner_count -
                    currentAssessmentStats.completed_scores_count
                )}
              />
              <h4 className="detail-name">Incomplete Assessments</h4>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: `${this.state.downloadCohort !== "" ? "block" : "none"}`,
          }}
        >
          <Loader color="#ff0033" loaded={loaded} />
        </div>
      );
    }
  }

  public performanceGrid() {
    const { breakdown, assessmentsLoaded, currentUserType } =
      this.props.dataCenterReducer;

    console.log({ breakdown });

    if (assessmentsLoaded) {
      return (
        <div className="alert-levels-holder">
          {breakdown.map((item, i) => (
            <div key={i} className="grid-item step-8">
              <h2 className="alert-title">{item.title}</h2>
              <div className="alert-visuals">
                <div className="school-alert-values step-11">
                  <CustomDonutChart
                    value={item.proportion * 1}
                    ploa={item.avg_ploa}
                    color="#e7233d"
                    alertLevel={item.title}
                    text={zeroPaddedStr(item.proportion) + "%"}
                  />{" "}
                  {/* GENERALLY TEXT SHOULD BE THE SAME AS VALUE */}
                  <h4 className="detail-name">
                    of{" "}
                    {currentUserType === "students"
                      ? "learners"
                      : currentUserType}{" "}
                    are in this level
                  </h4>
                </div>

                <div className="school-alert-values step-9">
                  <CustomDonutChart
                    value={item.avg_ploa}
                    color="#f56f3f"
                    text={zeroPaddedStr(Math.round(item.avg_ploa))}
                    alertLevel={item.title}
                  />{" "}
                  {/* GENERALLY TEXT SHOULD BE THE SAME AS VALUE */}
                  <h4 className="detail-name">
                    Average Performance Learning score
                  </h4>
                </div>

                <div className="school-alert-values school-speedo step-10">
                  <CustomSingleSpeedo
                    assessmentValue={item.avg_ploa}
                    color="#18ee97"
                    backgroundColor="#000"
                    alertLevel={item.title}
                  />{" "}
                  {/* GENERALLY TEXT SHOULD BE THE SAME AS VALUE */}
                  <h4 className="detail-name">Assessment Level</h4>
                </div>
              </div>
              {/*tslint:disable-next-line jsx-no-lambda*/}
              <div className="alert-level-actions">
                <button
                  className="green-button level-video"
                  onClick={this.openVideoModal.bind(this, item.video.embed.id)}
                  style={{
                    display: `${
                      currentUserType === "teachers" ? "none" : "block"
                    }`,
                  }}
                >
                  Learn more about this level
                </button>
                <button
                  className="blue-button explore-performance"
                  onClick={this.exploreLevelData.bind(this, item)}
                >
                  {currentUserType === "teachers"
                    ? "EXPLORE TEACHER RESULTS"
                    : "EXPLORE LEARNER PERFORMANCE"}
                </button>
              </div>
            </div>
          ))}
        </div>
      );
    } else {
      return "";
    }
  }

  public scatterPloa() {
    const { assessmentsLoaded, currentUserType, cohorts, breakdown } =
      this.props.dataCenterReducer;

    console.log({ cohorts });
    return (
      <div
        style={{
          display: `${!assessmentsLoaded ? "none" : "flex"}`,
        }}
        className="scatter-ploa step-7"
      >
        <h2 className="scatter-title">
          {currentUserType === "students" ? "learners" : currentUserType} per
          Alert Level vs Assessments
        </h2>
        {/* <CustomScatterGraph /> */}
        <StackedBarGraph data={cohorts} userType={currentUserType} />
        <button
          onClick={this.toggleDownloadModal}
          className="blue-button generate-report"
          style={{
            padding: "0.5em 1em",
            marginTop: "1.5em",
            width: "300px",
            display: "none",
          }}
        >
          Generate Report
        </button>
      </div>
    );
  }

  public schoolResources() {
    if (!this.state.deactivateForFE) {
      return (
        <div className="school-res-center">
          <h2 className="school-res-title">RESOURCES</h2>
          <div className="school-res-content">
            <div className="school-summary-values resources-available">
              <CustomDonutChart
                value={100}
                text="204"
                color="#18ee97"
                alertLevel="no"
              />
              <h4 className="detail-name">Resources Available</h4>
            </div>
            <Scrollbars
              className="school-res-disparea"
              style={{ height: "500px" }}
            >
              <div className="school-res">
                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>

                <div className="res-item">
                  <p className="res-description">
                    Understand Moderate level 3 results
                  </p>
                  <button
                    className="blue-button watch-res"
                    onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
                  >
                    watch now
                  </button>
                </div>
              </div>
            </Scrollbars>
          </div>
          <button
            className="blue-button download-overview"
            onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
          >
            DOWNLOAD OVERVIEW REPORT
          </button>
        </div>
      );
    } else {
      return <div />;
    }
  }

  public renderFirstScreen() {
    return (
      <div style={{ width: "80%", marginLeft: "2em" }}>
        <h4
          className="welcome-message"
          style={{
            width: "auto",
            textAlign: "center",
            marginTop: "1em",
            marginBottom: "-.75em",
          }}
        >
          Welcome <span>{currentUser()}</span>
        </h4>
        <div className="school-center-header">
          <h1 className="dashboard-name">Progress & Attainment Dashboard</h1>
        </div>
        {this.assessmentPicker()}
        {this.overallProgress()} {/* end overallprogress */}
        {this.schoolProfile()}
        {/* end school profile */}
        {this.scatterPloa()}
        <div className="school-alert-levels">{this.performanceGrid()}</div>
        {/* {this.reportCommands()} */}
        {/* {this.uploadActions()} */}
        {this.schoolResources()}
      </div>
    );
  }

  public renderVideoModal = () => {
    return (
      <ModalVideo
        channel="vimeo"
        isOpen={this.state.isVidModalOpen}
        onClose={this.closeVideoModal}
        videoId={this.state.videoLink}
        style={{ border: "3px solid #fff", padding: "10px" }}
      />
    );
  };
  public render() {
    if (!isUserLoggedIn()) {
      return <Redirect to="/login" />;
    }

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }

    return (
      <div>
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        {/* {this.renderUploadCompleteModal()} */}
        {this.renderVideoModal()}

        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div style={{ width: "100vw" }}>
            <ToastContainer />
            <Navbar
              logoutParent={this.onLogout}
              profileParent={this.onProfile}
            />
            <ClickOutside onClickOutside={this.onClickOutside}>
              <Sidenav
                onSelect={this.chooseCategory}
                className="datacenter-nav step-15"
                expanded={this.state.sideNavOpen}
                onToggle={this.toggleSideNav}
              >
                <Sidenav.Toggle />
                <Sidenav.Nav defaultSelected="summary">
                  <NavItem eventKey="summary">
                    <NavIcon>
                      {/* icon goes here */}
                      {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon1}/> */}
                      <span
                        className="navicon"
                        style={
                          this.state.sideNavCategory === "summary"
                            ? { color: "#ff0033" }
                            : { color: "#fff" }
                        }
                      >
                        S
                      </span>
                    </NavIcon>
                    <NavText>Summary</NavText>
                  </NavItem>
                  <NavItem eventKey="perceptions">
                    <NavIcon>
                      {/* icon goes here */}
                      {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> */}
                      <span
                        className="navicon"
                        style={
                          this.state.sideNavCategory === "perceptions"
                            ? { color: "#ff0033" }
                            : { color: "#fff" }
                        }
                      >
                        P
                      </span>
                    </NavIcon>
                    <NavText>Perceptions</NavText>
                  </NavItem>
                  {/* <NavItem
                    style={{
                      display: `${
                        this.props.dataCenterReducer.currentUserType ===
                        "teachers"
                          ? "block"
                          : "none"
                      }`,
                    }}
                    eventKey="teacherlist"
                  >
                    <NavIcon>
                      {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> 
                      <span
                        className="navicon"
                        style={
                          this.state.sideNavCategory === "my-assessments"
                            ? { color: "#ff0033" }
                            : { color: "#fff" }
                        }
                      >
                        TS
                      </span>
                    </NavIcon>
                    <NavText>Teacher List</NavText>
                  </NavItem> */}
                  {/* <NavItem eventKey="filters">
                    <NavIcon>
                      {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> 
                      <span
                        className="navicon"
                        style={
                          this.state.sideNavCategory === "my-assessments"
                            ? { color: "#ff0033" }
                            : { color: "#fff" }
                        }
                      >
                        SF
                      </span>
                    </NavIcon>
                    <NavText>Search Filters</NavText>
                  </NavItem> */}
                </Sidenav.Nav>
              </Sidenav>
            </ClickOutside>

            <div className="school-data-center">
              {this.getCurrentScreen()}

              {/* <FabButton
                className="toggle-video"
                right="8px"
                bottom="calc(80% - 200px)"
                bgColor="#1a1a1a"
                onClick={this.openVideoModal.bind(this, "525083745")}
              >
                <p className="fab-text">Video Guide</p>
                <i
                  className="fa fa-info"
                  style={{ fontSize: "30px", color: "#acff24" }}
                />
              </FabButton> */}

              <FabButton
                className="toggle-tour"
                right="8px"
                bottom="80%"
                bgColor="#1a1a1a"
                onClick={this.toggleGuides}
              >
                <p className="fab-text">Need a hand</p>
                <i
                  className="fa fa-question"
                  style={{ fontSize: "30px", color: "#ff0033" }}
                />
              </FabButton>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataCenterReducer: state.teacherDCReducer,
  };
};

export default connect(mapStateToProps)(withServices(TeacherDataCenter));



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Teacher/TeacherDataCenter.Component.tsx